const config = {
    API_URL: "https://api.rbkassistance.com"
    //API_URL: "https://rbkappapi.azurewebsites.net"

};

export default config;
